import {
  Button,
  Box,
  TextField,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { EmailVerificationRequest } from '../../../services/authentication.types';
import { emailVerificationSchema } from '../../../validation/schemas/emailVerificationSchema';
import EmailSent from '../Confirmations/EmailSent';
import api from '../../../services/api';

function VerifyEmail({ forgotPassword = false, changeEmail = false }) {
  // variables
  const [isEmailSent, setIsEmailSent] = useState(false);

  // form
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<EmailVerificationRequest>({
    mode: 'onSubmit',
    resolver: yupResolver(emailVerificationSchema),
    criteriaMode: 'all',
    defaultValues: {
      email: '',
    },
  });

  // functions
  const onRegisterNewUserConfirm = handleSubmit(async () => {
    api.post('/auth/verify/register-email', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  const onForgotPasswordConfirm = handleSubmit(async () => {
    api.post('/auth/forgot-password', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  const onChangeEmailConfirm = handleSubmit(async () => {
    api.post('/v1/users/send-email-change', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  // render conditions
  if (isEmailSent) {
    return <EmailSent forgotPassword={forgotPassword} changeEmail={changeEmail} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {(forgotPassword && 'パスワード再設定') || (changeEmail && 'メールアドレス変更') || (!forgotPassword && !changeEmail && '会員登録')}
          - BUILD-SELF
        </title>
      </Helmet>
      <main className="d-flex w-100 h-100 login-background">
        <div className="container d-flex flex-column">
          <div className="vh-100">
            <div className="mx-auto d-table h-100 w-50">
              <div className="d-table-cell align-middle">
                <Box className="text-center my-4" sx={{ width: '100%' }}>
                  <img
                    className="img-fluid mb-4"
                    width="180"
                    height="48"
                    src="/img/logo.png"
                    alt="ビルドセルフ - BUILD-SELF"
                  />
                  <Box>
                    <h1 className="mb-2 fw-bold">
                      {forgotPassword && 'パスワード再設定'}
                      {changeEmail && 'メールアドレス変更'}
                      {!forgotPassword && !changeEmail && '会員登録'}
                    </h1>
                  </Box>
                  <Box>
                    <Typography
                      fontSize={12}
                    >
                      {forgotPassword && 'ご登録メールアドレスに、パスワード再設定のURLをお送りいたします。'}
                      {changeEmail && 'メールアドレスを変更するためのメールを送信します。'}
                      {!forgotPassword && !changeEmail && 'ご入力いただいたメールアドレスに、本人確認用メールをお送りします。'}
                    </Typography>
                  </Box>
                </Box>

                <Box className="card">
                  <Box className="card-body">
                    <label className="form-label w-100">
                      メールアドレス
                    </label>
                    <TextField
                      {...register('email')}
                      placeholder="mail@build-self.com"
                      variant="outlined"
                      size="small"
                      error={!!errors.email}
                      helperText={errors.email?.message || ' '}
                      fullWidth
                    />

                    <Button
                      onClick={(forgotPassword && onForgotPasswordConfirm)
                        || (changeEmail && onChangeEmailConfirm)
                        || onRegisterNewUserConfirm}
                      variant="contained"
                      className="w-100"
                    >
                      メールを送信する
                    </Button>
                  </Box>
                </Box>
                {/* <div className="version mt-1 mx-1">version 0.0.1</div> */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default VerifyEmail;
